<template>
  <div class="mr-2 relative flex items-center">
    <router-link :to="dashboardPath+'/messages'">
      <message-icon class="w-6 lg:w-8"
      :class="$route.fullPath === dashboardPath+'/messages' ?
      'text-'+textColor : 'hover:text-'+textColor" />
    </router-link>
    <span
      class="rounded-full w-5 h-5 flex justify-center items-center ml-4 lg:ml-5
        text-sm font-bold mb-5 absolute font-sans-serif"
        :class="isTeacher ? 'bg-beige-academy-300 text-white': 'bg-orange-academy-300 text-white'"
        v-if="messagesToRead.length>0"
      >
      {{messagesToRead.length}}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MessageIcon from './MessageIcon.vue';

export default {
  props: ['textColor'],

  components: {
    MessageIcon,
  },

  computed: {
    ...mapGetters({
      isTeacher: 'auth/isTeacher',
      messagesToRead: 'auth/messagesToRead',
      dashboardPath: 'auth/dashboardPath',
    }),

  },
};
</script>
